const $ = window.jQuery

import appUtils from './app_utils';
import hscroll from './hscroll';

const openOnHover = false

const navigationSelector = "#modal-1-content"
const menuContainerSelector = "#modal-1-content ul.navigation--main"
const menuItemsSelector = "#modal-1-content ul.navigation--main > li"
const submenuContainerSelector = "[data-main-navigation-subnav]"

const jsOverCssClass = 'js-active' // 'js-over-active'

let $activeItem = null
let $activeSubMenu = null
let timer = null
let $submenuContainer = null

const submenuReset = function() {
  if($activeSubMenu && $activeItem){
    const hscrollInstance = $activeSubMenu.data('hscroll-instance')
    if (hscrollInstance) {
      hscrollInstance.destroy()
    }
    $activeItem.find('button[aria-expanded="true"]').attr('aria-expanded', 'false')
    if($activeItem){
      $activeItem.removeClass(jsOverCssClass)
    }
  }
  $submenuContainer.html('')
  $activeItem = null
  $activeSubMenu = null
}

const init = function() {
  const $nav = $(navigationSelector)
  const $menuContainer = $(menuContainerSelector)
  const $menuItems = $(menuItemsSelector)
  const $header = $('header.wp-block-template-part')
  if (openOnHover) {
    $header.append('<div data-main-navigation-subnav ></div>')
  } else {
    $('main.wp-block-group').prepend('<div class="alignfull" data-main-navigation-subnav ></div>')
  }
  
  $submenuContainer = $(submenuContainerSelector)
  $submenuContainer.html('')

  
  let $currentMenuItem =  $(menuItemsSelector + ' .current-menu-ancestor').parent().first()
  if (!$currentMenuItem.length) {
    $currentMenuItem = $(menuItemsSelector + '.current-menu-item').first()
  }
  const overCheck = function($this){
    if( $nav.data('overItem') === $this.data('item-index') && $nav.data('openItem') !== $this.data('item-index') ){
      $nav.data('openItem', $this.data('item-index'));

      /*
      * activesubmenu cloned to $submenuContainer
      */
      submenuReset()

      const $subMenuOriginal = $this.find('> ul') // $this.data('submenu');
      if($subMenuOriginal.length){
        const $subMenu = $subMenuOriginal.clone()
        $subMenu.attr('data-hscroll', 'window')
        $submenuContainer.append($subMenu)
        $activeSubMenu = $subMenu;
        
        const smEelement = $subMenu[0]
        const hscrollInstance = new hscroll.HScroll(smEelement)
        
        // update scrollbar size
        /*
        const submenuScrollbarInstance = $subMenu.data('scrollbar-instance')
        if (submenuScrollbarInstance) {
          submenuScrollbarInstance.update();
        }
        */

        $this.addClass(jsOverCssClass)
        $this.find('button[aria-expanded="false"]').attr('aria-expanded', 'true')
      }
      /*
      * end activeSubmenu cloned to $submenuContainer
      */

      $activeItem = $this;

      timer = null;
    }
  }

  const overReset = function() {
    if($currentMenuItem.length) {
      $nav.data('overItem', $currentMenuItem.data('item-index'))
      overCheck($currentMenuItem)
    } else {
      submenuReset()
      $nav.data('openItem', '--')
    }
  }

  //reference cache al sottomenu
  $menuItems.each(function(index){
    $(this).data('item-index', index);
  })

  $nav.data('openItem', '--')
  overReset()

  //Chiusura popover quando abbandono l'area del menu
  //The mouseout event triggers when the mouse pointer leaves any child elements as well the selected element.
  //The mouseleave event is only triggered when the mouse pointer leaves the selected element.
  if (appUtils.isTouch()) {
    $(menuItemsSelector + '.has-child').on('click', function(e) {
      const $li = $(this)
      if ($li.is('.' + jsOverCssClass)) {
        return true
      } else {
        $nav.data('overItem', $li.data('item-index'))
        overCheck($li)
      }

      e.preventDefault()
      e.stopPropagation()
    })
  } else {
    
    if (openOnHover) {
      $header.on('mouseleave', function() {
        if(timer) { clearTimeout(timer) }
    
        timer = setTimeout(function() {
          overReset()
    
          timer = null;
        }, 600)
      })
      $menuContainer.on('mouseleave', function() {
        if(timer) { clearTimeout(timer) }
        $nav.data('overItem', $nav.data('openItem'));
      })
    
      //apertura popover con timer
      $menuItems.on('mouseenter', function() {
        const $this = $(this)
        $nav.data('overItem', $this.data('item-index'))
        if(timer) { clearTimeout(timer) }
  
        timer = setTimeout( function() {overCheck($this) }, 400)
      })
    }
 
  }
  
}

const destroy = function() {
  if (appUtils.isTouch()) {
    $(menuItemsSelector + '.has-child').off('click')
  } else {
    $(navigationSelector).off('mouseleave')
    $(menuContainerSelector).off('mouseleave')
    $(menuItemsSelector).off('mouseenter')
  }


  submenuReset()

  if(timer) { clearTimeout(timer) }
  timer = null
}



export default {init, destroy}
